export enum GrupoPessoaTipoEnum {
  FOCAL_FINANCEIRO = 'FOCAL_FINANCEIRO',
  FOCAL_OPERACIONAL = 'FOCAL_OPERACIONAL',
  RESPONSAVEL_NEGOCIACAO = 'RESPONSAVEL_NEGOCIACAO',
  RESPONSAVEL_LEGAL = 'RESPONSAVEL_LEGAL',
}

